import { mergeStyleSets } from "office-ui-fabric-react/lib/Styling";

export const classNames = mergeStyleSets({
	commandBarWrapper: {
		borderBottom: "1px solid #EDEBE9"
	},
	commandBar: {
		width: "98%",
		margin: "0 auto",
	}
});
